import axios from "axios"
import {formMethod} from "@main/helpers"

document.addEventListener("DOMContentLoaded", function() {

    const $form = $("form.js-form-filter");

    $form.on("submit", function(e) {

        e.preventDefault();

        const $vesa = $(".js-vesa");
        const url = $vesa.attr("data-url");
        const $inputs = $vesa.find(".js-vesa-input");

        const vesaParams = getVesaParams($inputs);

        const currentUrl = "?" + $form.serialize() + getSelectParams($form) + getSortParams($form);
        if (vesaParams) {
            vesaParams["current-url"] = currentUrl;

            axios({
                url: url,
                params: vesaParams,
                method: formMethod("GET"),
                headers: {"Content-Type": "application/x-www-form-urlencoded"},

            }).then(res => {

                if (res.data.success) {
                    window.location.href = res.data.url;
                } else {

                    $vesa.addClass("result");
                    $inputs.val("");

                    const $wrap = $vesa.find(".js-vesa-items");
                    const items = [...res.data.data.value].map((value) => {

                        return `<a href="${value.url}" class="vesa__result-item">${value.text}</a>      `;
                    }).join("");

                    $wrap.html(items);
                    $vesa.get(0).scrollIntoView();
                }

            }).catch(() => {
                alert("Что-то пошло не так...\nПопробуйте обновить страницу");
            });

        } else {
            $form.unbind("submit").submit();
        }



    });

    function getVesaParams(inputs) {

        const params = {};

        let isEmpty = false;
        let noVesa = true;

        inputs.each(function() {
            noVesa = false;
            const name = $(this).attr("name");
            const value = $(this).val();

            if (!value) {
                isEmpty = true;
            }

            params[name] = value;
        });
        if (noVesa) {
            return null;
        }
        return isEmpty ? null : params;
    }


    function getSelectParams(form) {

        let params = "";

        form.find(".js-select-btn").each(function() {

            const name = $(this).attr("data-name");
            const value = $(this).attr("data-value");

            params += "&"+name+"=" + value;
        });

        return params;
    }

    function getSortParams() {

        let params = "";

        $(".js-sort").each(function() {

            if ($(this).hasClass("active")) {

                const sort = $(this).attr("data-sort");

                params += "&sort=" + sort;
            }

        });

        return params;
    }
});
